module.exports = __webpack_public_path__ + "momtalkingtomoms_logo1.0_white.svg?a8451b6fb5fba9ca8e84e255461ba0c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/momtalkingtomoms_logo1.0_white.svg
// module id = 47
// module chunks = 0